import React from 'react'

import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  FieldPrefix,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import AddressPickerAdvanced from '../../../AddressPickerAdvanced'
import AddressPickerAdvancedReadonly from '../../../AddressPickerAdvanced/Readonly'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { useProductSettings } from '../../Products'
import useCustoms from '../Customs/useCustoms'
import ReadonlyAddressCache from '../ReadonlyAddressCache'

interface TImporterAddressProps
  extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  readonly?: boolean
}

const ImporterAddress = (props: TImporterAddressProps): React.ReactElement => {
  const { readonly, ...rest } = props

  const [isEdit, setIsEdit] = useField('isEdit', { asState: true })

  const { isCustomsRequired } = useCustoms()

  const { importerAddressIsDisplayed } = useProductSettings()

  const isVisible = isCustomsRequired && importerAddressIsDisplayed !== false

  return (
    <>
      <ReadonlyAddressCache />
      {isVisible && (
        <OrderEntryCard
          {...rest}
          title={i18n.t('importer_address', 'Importeur/Fiskalvertreter')}
        >
          {!readonly && (
            <Field name="isEdit">
              <Checkbox
                label={i18n.t(
                  'different_importer_address',
                  'Abweichend von Auftraggeber',
                )}
                tooltip={i18n.t(
                  'different_importer_address',
                  'Diese Angabe ist nur relevant, wenn abweichende Angaben für die Proformarechnung erforderlich sind',
                )}
              />
            </Field>
          )}
          <FieldPrefix prefix="address">
            {!readonly && isEdit ? (
              <AddressPickerAdvanced />
            ) : (
              <AddressPickerAdvancedReadonly />
            )}
          </FieldPrefix>
        </OrderEntryCard>
      )}
    </>
  )
}

export default ImporterAddress
